import { Component, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../services/auth.service';
import { AppRole } from '../../models/permissions.model';

type Lang = 'it' | 'en';

@Component({
  selector: 'app-accessibility-declaration',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './accessibility-declaration.component.html',
  styleUrl: './accessibility-declaration.component.scss',
})
export class AccessibilityDeclarationComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  lang = signal<Lang>('it');

  readonly returnButtonLabel = signal('Torna ad area personale');

  constructor() {
    const roles = this.authService.getCurrentUser()?.roles ?? [];
    const isBackofficeUser = roles.includes(AppRole.BACKOFFICE_SUPPLIER) ||
      roles.includes(AppRole.BACKOFFICE_PROFESSIONAL) ||
      roles.includes(AppRole.BACKOFFICE_ADMIN) ||
      roles.includes(AppRole.SUPER_ADMIN);

    if (isBackofficeUser) {
      this.returnButtonLabel.set('Torna alla home');
    }
  }

  setLang(lang: Lang): void {
    this.lang.set(lang);
  }

  goHome(): void {
    if (this.authService.isAuthenticated()) {
      const roles = this.authService.getCurrentUser()?.roles ?? [];
      const isBackofficeUser = roles.includes(AppRole.BACKOFFICE_SUPPLIER) ||
        roles.includes(AppRole.BACKOFFICE_PROFESSIONAL) ||
        roles.includes(AppRole.BACKOFFICE_ADMIN) ||
        roles.includes(AppRole.SUPER_ADMIN);

      if (isBackofficeUser) {
        this.router.navigateByUrl(this.authService.getDefaultRouteForUser());
        return;
      }

      // Usa redirectAfterAuthentication che gestisce correttamente il flusso
      // professional/collaborator (controlla profilo → progress o pre-registration)
      this.authService.redirectAfterAuthentication();
    } else {
      this.router.navigate(['/login']);
    }
  }
}
